"use client";
import React, { useContext } from "react";
import "./Navbar.css";
import cart from "../../assets/cafe/cart.png";
import { Link } from "react-router-dom";
import { ShopContext } from "../../../context/ShopContext";

const Cart = () => {
    const { getTotalCartItems } = useContext(ShopContext);
    return (
        <>
            <Link to='/cart'><img src={cart} alt="" /></Link>
            <div className="nav-cart-count">{getTotalCartItems()}</div>
        </>
    )
}

export default Cart;